import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { intercomConstants } from "@data/constants/intercomConstants"
import { authService } from "@data/services/authService"
import { familyService } from "@data/services/familyService"

const initialState = {
    userJwt: null, // JWT for Intercom Messenger Security (web + native)
    jwtUserId: null, // user.id the JWT was minted for — guards a stale token binding to a switched user
    jwtFetchedAt: null, // device timestamp of the last token fetch — drives proactive refresh before the 24h server exp
    ready: false, // True once the Intercom SDK session is live (login + setUserJwt resolved)
    pendingOpen: false, // A support-reply push was tapped — open the messenger once the session is live
    pendingConversationId: null, // The replied conversation to open on that tap, so we land on the thread not the inbox
    unreadCount: 0, // Unread conversation count from the Intercom SDK — drives the help bubble badge
}

export default function intercom(state = initialState, action) {
    switch (action.type) {
        case familyService.getIntercomIdentityToken.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                userJwt: action.data.user_jwt,
                jwtUserId: action.data.user_id,
                jwtFetchedAt: new Date().getTime(),
            }

        // Re-identification (family / sibling switch): reset to a fresh session
        // for the new identity, but keep pendingOpen so a tapped reply push still
        // opens after re-auth.
        case intercomConstants.RESET_INTERCOM_IDENTIFICATION:
            return {
                ...initialState,
                pendingOpen: state.pendingOpen,
                pendingConversationId: state.pendingConversationId,
            }

        case intercomConstants.SET_INTERCOM_READY:
            return {
                ...state,
                ready: action.ready,
            }

        case intercomConstants.SET_PENDING_INTERCOM_OPEN:
            return {
                ...state,
                pendingOpen: action.pending,
                pendingConversationId: action.pending
                    ? (action.conversationId ?? null)
                    : null,
            }

        case intercomConstants.SET_INTERCOM_UNREAD_COUNT:
            return {
                ...state,
                unreadCount: action.count || 0,
            }

        // Logout / impersonation boundaries drop the whole session, pending open included.
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
        case authService.revokeSanctumToken.name + apiConstants._SUCCESS:
        case authService.deleteAccount.name + apiConstants._SUCCESS:
        case authService.bootstrapImpersonation.name + apiConstants._SUCCESS:
        case authService.exitImpersonation.name + apiConstants._SUCCESS:
            return initialState

        default:
            return state
    }
}
